module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan-reservation-rates"
  }, _vm._l((_vm.planRates), function(rate) {
    return _c('plan-reservation-rate', {
      attrs: {
        "item": rate,
        "type": "listing"
      },
      on: {
        "deleted": _vm.load
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-593f3d28!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/PlanReservationRates.vue
// module id = 2367
// module chunks = 1